import css from './routeHistoryListItem.module.css'
import cn from '@/utils/cn'
import LinkIcon from '@/assets/icons/externalLink.svg?react'
import FileListIcon from '@/assets/icons/fileList.svg?react'

interface IProps {
  routeHistory: { routeName: string; title: string }
  onClick: () => void
}

const RouteHistoryListItem = (props: IProps) => {
  return (
    <div
      key={props.routeHistory.routeName}
      onClick={props.onClick}
      className={cn('inline-flex-gap gap12 center', css.wrapper)}
    >
      <FileListIcon height="16px" width="16px" color="var(--text-default)" style={{ flexShrink: 0 }} />
      <p className="text-nm line-clamp">{props.routeHistory.title}</p>
      <LinkIcon className={css.linkIcon} style={{ marginLeft: 'auto' }} />
    </div>
  )
}

export default RouteHistoryListItem
